import api from '../../utils/api';

export interface InstantConsultationQueueRow {
  clinicAppointmentId: string;
  appointmentId: string;
  userId: string;
  userName: string | null;
  userPhone: string | null;
  selectedSpeciality: string | null;
  selectedSpecialityId: string | null;
  status: string;
  paymentStatus: string;
  paidAmount: number;
  acceptedInstantFee?: number | null;
  date: string;
  time: string;
  expiresAt: string | null;
  queueStatus: 'pending' | 'assigned' | 'cancelled';
  vendorsNotified: number;
  requestedVendorNames: string[];
  requestedVendors: Array<{
    inviteId: string | null;
    vendorId: string;
    name: string;
    kind: string;
    inviteStatus: string | null;
    inviteMode: string | null;
  }>;
  acceptedByVendorId: string | null;
  acceptedByVendorName: string | null;
  cancelledBy?: 'doctor' | 'user' | 'admin' | null;
  cancellationReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InstantConsultationQueueResponse {
  success: boolean;
  data: {
    queue: InstantConsultationQueueRow[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
}

export async function getInstantConsultationQueue(params?: {
  page?: number;
  limit?: number;
  search?: string;
  status?: 'pending' | 'assigned' | 'cancelled' | 'all';
}): Promise<InstantConsultationQueueResponse> {
  const { page = 1, limit = 100, search = '', status = 'all' } = params || {};
  const response = await api.get<InstantConsultationQueueResponse>(
    '/master-admin/instant-consultation-queue',
    {
      params: { page, limit, search, status },
    }
  );
  return response.data;
}
